import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";

import Sidebar from "../../../components/Navigation/Sidebar";
import Topbar from "../../../components/Navigation/Topbar";
import Header from "../../../components/Page/header";
import Grid from '../../../components/Grid';

import { buttonIcon, buttonTypes } from "../../../utils/buttonsUtil";
import formatDateWithCustomFormat from "../../../utils/formatDate";

const WMSTransfer = ({
    transfers,
    reduxGetTransfers,
}) => {
    const history = useHistory();

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    useEffect(() => {
        handleSearch();
    }, [currentPage, pageSize]);

    const handleSearch = () => {
        reduxGetTransfers({
            page: currentPage,
            pageSize,
        });
    }

    const columns = [
        {
            title: "#",
            render: (data) => <span>{data.transferNumber}</span>,
        },
        {
            title: "Hub Origen",
            render: (data) => <span>{data.originHub.branchName}</span>,
        },
        {
            title: "Hub Destino",
            render: (data) => <span>{data.destinationHub.branchName}</span>,
        },
        {
            title: "Manifiesto de Salida",
            render: (data) => <span>{data.idOutboundManifest || '-'}</span>,
        },
        {
            title: "Manifiesto de Entrada",
            render: (data) => <span>{data.idInboundManifest || '-'}</span>,
        },
        {
            title: "Estado",
            render: (data) => <span>{data.status.displayName}</span>,
        },
        {
            title: "Fecha de Creación",
            render: (data) => <span>{formatDateWithCustomFormat(data.createdAt, 'DD/MM/YYYY')}</span>,
        },
        {
            title: "Creado Por",
            render: (data) => <span>{data.creator.firstName + ' ' + data.creator.lastName}</span>,
        }
    ];

    const actionButtons = [
        {
            onClick: () => history.goBack(),
            buttonType: buttonTypes.Primary,
            buttonIcon: buttonIcon.Arrow_LeftReply,
        },
        {
            permission: "feature:wms-transfers-create",
            onClick: () => history.push('/wms/transfers/outbound'),
            buttonType: buttonTypes.Success,
            buttonIcon: buttonIcon.Add,
        }
    ];

    return (
        <>
            <div id="wrapper">
                <Sidebar />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Topbar />
                        <div className="container-fluid">
                            <Header title={"Traslados"} subtitle={"Listado de Traslados"} actionButtons={actionButtons} />
                        </div>
                        <div className="card shadow mb-4">
                            <div className="card-body">
                                <div className="d-flex justify-content-end mb-2">
                                    <button className="btn btn-primary" onClick={() => handleSearch()}>Buscar</button>
                                </div>
                                <Grid
                                    showFilters={false}
                                    cols={columns}
                                    data={
                                        transfers && Object.keys(transfers).length > 0 ? transfers.data : []
                                    }
                                    page={
                                        transfers && Object.keys(transfers).length > 0
                                            ? Number(transfers.pagination.page)
                                            : currentPage
                                    }
                                    pages={
                                        transfers && Object.keys(transfers).length > 0
                                            ? Number(transfers.pagination.totalPages)
                                            : 0
                                    }
                                    total={
                                        transfers && Object.keys(transfers).length > 0
                                            ? Number(transfers.pagination.total)
                                            : 0
                                    }
                                    offset={pageSize}
                                    onChangePage={(value) => {
                                        setCurrentPage(value)
                                    }}
                                    onChangeRange={(value) => {
                                        setPageSize(value);
                                    }}
                                >
                                </Grid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        transfers: state.wmsTransfersState.transfers,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        reduxGetTransfers: (payload) =>
            dispatch({
                type: "FETCH_WMS_TRANSFERS_REQUEST",
                value: payload,
            }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WMSTransfer);
